import React from 'react';
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { setPopup } from '../../../redux/messageSlice';

const Downloading = () => {
    const dispatch = useDispatch()
    const { downloading_file, downloading_progress } = useSelector(state => state.message)


    return (

        <div className="downloadingPopupCon">
            <div className="downloadingPopup">
                <div className="downloadingHead flex justify-between">
                    <span className="downloadingTitle">
                        Downloading
                        <span style={{ marginLeft: '15px' }} className="downloadingFileName">
                            {downloading_file?.length > 0 ? downloading_file?.[0].progress : ''}
                        </span>
                    </span>
                    <MdClose className='text-2xl text-white' onClick={() => dispatch(setPopup({ key: 'downloading_progress', value: {} }))} />
                </div>
                <div className="downloadingBody">
                    {
                        Object.keys(downloading_progress).length ? Object.keys(downloading_progress).map((key, i) =>
                            <div key={'k_' + i} className="downloadingFile">
                                <span className="downloadingFileName">{key}</span>
                                <span className="downloadingFileName">{downloading_progress[key]}</span>
                            </div>
                        ) : ''
                    }
                </div>
            </div>
        </div>
    );
};

export default Downloading;